import { FC, SVGProps } from 'react'

export const Check: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M20.2672 5.2069C20.5672 5.49256 20.5788 5.9673 20.2931 6.26724L8.86453 18.2672C8.72298 18.4159 8.52669 18.5 8.32143 18.5C8.11617 18.5 7.91988 18.4159 7.77833 18.2672L3.2069 13.4672C2.92123 13.1673 2.93281 12.6926 3.23276 12.4069C3.53271 12.1212 4.00744 12.1328 4.2931 12.4328L8.32143 16.6625L19.2069 5.23276C19.4926 4.93281 19.9673 4.92123 20.2672 5.2069Z"
			fill="currentColor"
		/>
	</svg>
)
